export default "__VITE_ASSET__DvrX4DM0__"